import React, { FC, MouseEvent } from 'react'
import useEditorActions from './useEditorActions'
import Box from '@mui/material/Box'

const EditorContainer: FC<React.PropsWithChildren> = ({
  children,
}) => {

  const {
    deselect,
  } = useEditorActions()

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
      }}
      onClick={ (e: MouseEvent<HTMLDivElement>) => {
        // when the user clicks on the whitespace let's de-select the current item
        if(!e.target) return
        const target = e.target as HTMLElement
        if(target.getAttribute('id') == 'editor-container') {
          deselect()
        }
      }}
    >
      { children }
    </Box>
  )

}

export default EditorContainer